// Shared auth paths for all user types (staff, patient, admin)
const SIGNIN_PATH = '/accounts/signin/';
const VERIFY_OTP_PATH = '/accounts/verify-otp/';
const LOGOUT_PATH = '/accounts/logout/';
const RESEND_OTP_PATH = '/accounts/resend-otp/';
const REFRESH_PATH = '/accounts/token/refresh/';

export const ROUTES = {
  // Sign-in: same for all user types
  LOGIN: SIGNIN_PATH,
  DASHBOARD_LOGIN: SIGNIN_PATH,
  // Verify OTP: same for all user types (response includes role: { id, name })
  VERIFY_LOGIN_OTP: VERIFY_OTP_PATH,

  // Resend OTP: same for all user types
  RESEND_LOGIN_OTP: RESEND_OTP_PATH,

  // Logout: same for all user types
  LOGOUT: LOGOUT_PATH,

  // Refresh token: same for all user types
  REFRESH_TOKEN: REFRESH_PATH,
};
